import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import formatDateTime from '@afosto/utils/date/formatDateTime';
import formatCurrency from '@afosto/utils/formatCurrency';
import { boolean } from '@afosto/app-components-react/DataGrid/formatters';
import translations from './translations';
import Chip from '@material-ui/core/Chip';
import CalculationFormatter from '../CalculationFormatter';
import TransactionFormatter from '../TransactionFormatter';
import PrepaidFormatter from '../PrepaidFormatter';

const AcceptanceListItem = ({ acceptance }) => {
  const intl = useIntl();

  const StatusChip = () => {
    const chipOptions = {
      label: intl.formatMessage(translations.chip.open),
      color: 'default',
      variant: 'outlined',
    };

    if (acceptance.is_paid) {
      chipOptions.label = intl.formatMessage(translations.chip.isPaid);
      chipOptions.color = 'primary';
      chipOptions.variant = 'outlined';
    }

    return (
      <Chip label={chipOptions.label} color={chipOptions.color} variant="outlined" size="small" />
    );
  };

  return (
    <>
      <Divider />
      <ListItem>
        <Box flex={1} py={1}>
          <Box display="flex" justifyContent="space-between" alignItems="baseline" mb={1}>
            <StatusChip />
            <Box display="flex" flexDirection="column" alignItems="flex-end">
              <Typography variant="caption" color="textSecondary" gutterBottom>
                {formatDateTime(acceptance.created_at)}
              </Typography>
            </Box>
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Typography variant="overline" color="textSecondary">
                {intl.formatMessage(translations.properties.calculation)}
              </Typography>
              <Typography variant="body2">
                <CalculationFormatter id={acceptance.calculation_id} />
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="overline" color="textSecondary">
                {intl.formatMessage(translations.properties.transaction)}
              </Typography>
              <Typography variant="body2">
                <TransactionFormatter secret={acceptance.transaction_secret} />
              </Typography>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <Typography variant="overline" color="textSecondary">
                  {intl.formatMessage(translations.properties.payment)}
                </Typography>
                <Typography variant="body2">
                  <PrepaidFormatter isPrepaid={acceptance.is_prepaid} />
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="overline" color="textSecondary">
                  {intl.formatMessage(translations.properties.isSettlement)}
                </Typography>
                <Typography variant="body2">{boolean(acceptance.is_settlement)}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="overline" color="textSecondary" align="right" component="div">
                  {intl.formatMessage(translations.properties.amount)}
                </Typography>
                <Typography variant="subtitle1" align="right">
                  {formatCurrency(acceptance.amount / 100)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </ListItem>
    </>
  );
};

AcceptanceListItem.propTypes = {
  acceptance: PropTypes.object,
};

AcceptanceListItem.defaultProps = {
  acceptance: null,
};

export default AcceptanceListItem;
